<template>
  <div>
    <el-table
      :data="tableData"
      :colAttr="colAttr"
      style="width: 100%"
      max-height="300"
    >
      <el-table-column
        width="100"
        align="center"
        v-for="(col, index) in colAttr"
        :key="index"
        :prop="col.prop"
        :label="col.label"
      >
      </el-table-column>
    </el-table>
  </div>
</template>
<script>
export default {
  name: "Table",
  methods: {
 
  },
  // 接收表格数据、字段属性
  props: ["tableData", "colAttr"],
};
</script>

<style>
</style>